export const AggregationPeriodTypes = [
  {
    value: "minute",
    label: "Minute(s)"
  },
  {
    value: "hour",
    label: "Hour(s)"
  },
  {
    value: "day",
    label: "Day(s)"
  },
  {
    value: "month",
    label: "Month(s)"
  },
  {
    value: "year",
    label: "Year(s)"
  }
];



// WEBPACK FOOTER //
// ./src/constants/AggregationPeriodTypes.js